import React__default, { Suspense } from 'react';

const Visible = ({ when, children }) => {
    if (!when) {
        return null;
    }
    return React__default.createElement(Suspense, { fallback: '' }, children);
};

export { Visible as default };
//# sourceMappingURL=Visible.js.map
